export const STICKERS = {
    duck_laugh: "https://s3.twcstorage.ru/246784d0-aniverse-files/webapp/stickers/duck_laugh.json",
    eyes: "https://s3.twcstorage.ru/246784d0-aniverse-files/webapp/stickers/eyes.json",
    dont_know: "https://s3.twcstorage.ru/246784d0-aniverse-files/webapp/stickers/dont_know.json",
    keyboard: "https://s3.twcstorage.ru/246784d0-aniverse-files/webapp/stickers/keyboard.json",
    lock_key: "https://s3.twcstorage.ru/246784d0-aniverse-files/webapp/stickers/lock_key.json",
    duck_loading: "https://s3.twcstorage.ru/246784d0-aniverse-files/webapp/stickers/duck_loading.json",
    duck_dont_know: "https://s3.twcstorage.ru/246784d0-aniverse-files/webapp/stickers/duck_dont_know.json",
    duck_bye: "https://s3.twcstorage.ru/246784d0-aniverse-files/webapp/stickers/duck_bye.json",
    duck_open: "https://s3.twcstorage.ru/246784d0-aniverse-files/webapp/stickers/duck_open.json",
    folder_empty: "https://s3.twcstorage.ru/246784d0-aniverse-files/webapp/stickers/folder_empty.json",
    cards: "https://s3.twcstorage.ru/246784d0-aniverse-files/webapp/stickers/cards.json",
};